import types from "rdx/modules/fileUpload/types";
import createAction from "rdx/utils/createAction";

export default {
  putGrayscaleCopy: (payload) => createAction(types.PUT_GRAYSCALE_COPY, payload),
  // INSERTION_PT (for script, do not remove)
};
